import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { AnalisisClinico } from '../../../pacientes/pacientes';

import { ArchivosAtencionService } from '../../../../core/services/archivos-atencion.service';

@Component({
  selector: 'app-analisis-clinico-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './analisis-clinico-dialog.html',
  styleUrl: './analisis-clinico-dialog.scss',
})
export class AnalisisClinicoDialog {
  private fb = inject(FormBuilder);

  archivoSeleccionado: File | null = null;
  archivoNombre: string | null = null;

  form = this.fb.group({
    estudio: ['', Validators.required],
    resumen: ['', Validators.required],
  });

  constructor(
    private dialogRef: MatDialogRef<AnalisisClinicoDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      analisis?: AnalisisClinico;
      index?: number;
      atencionId?: string;
    },
  ) {
    if (data?.analisis) {
      this.form.patchValue({
        estudio: data.analisis.estudio,
        resumen: data.analisis.resumen,
      });

      this.archivoNombre = data.analisis.archivoNombre ?? null;
    }
  }

  onArchivoSeleccionado(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.archivoSeleccionado = input.files[0];
      this.archivoNombre = input.files[0].name;
    }
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const resultado: AnalisisClinico = {
      estudio: this.form.get('estudio')?.value ?? '',
      resumen: this.form.get('resumen')?.value ?? '',
      archivo: this.archivoSeleccionado,
      archivoNombre: this.archivoNombre,
      fecha: new Date(),
    };

    this.dialogRef.close(resultado);
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}
